
      var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRetriveQrCode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "retrive-qr-code_4bca5505b616b377__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 5.995,
  width: 14,
  height: 14,
  rx: 1.375
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 5.995,
  width: 14,
  height: 14,
  rx: 1.375,
  stroke: "#000",
  strokeWidth: 3.2,
  mask: "url(#retrive-qr-code_4bca5505b616b377__a)"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "retrive-qr-code_4bca5505b616b377__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 23.995,
  width: 14,
  height: 14,
  rx: 1.375
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 23.995,
  width: 14,
  height: 14,
  rx: 1.375,
  stroke: "#000",
  strokeWidth: 3.2,
  mask: "url(#retrive-qr-code_4bca5505b616b377__b)"
})), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
  id: "retrive-qr-code_4bca5505b616b377__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 5.995,
  width: 14,
  height: 14,
  rx: 1.375
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 5.995,
  width: 14,
  height: 14,
  rx: 1.375,
  stroke: "#000",
  strokeWidth: 3.2,
  mask: "url(#retrive-qr-code_4bca5505b616b377__c)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M24 23.995h3.5v3.5H24zm3.5 3.5H31v3.5h-3.5zm3.5-3.5h3.5v3.5H31zm-7 7.001h3.5v3.5H24zm3.5 3.499H31v3.5h-3.5zm3.5-3.499h3.5v3.5H31zm3.5-3.501H38v3.5h-3.5zm0 7H38v3.5h-3.5z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\"><mask id=\"a\" fill=\"#fff\"><rect x=\"6\" y=\"5.995\" width=\"14\" height=\"14\" rx=\"1.375\"/></mask><rect x=\"6\" y=\"5.995\" width=\"14\" height=\"14\" rx=\"1.375\" stroke=\"#000\" stroke-width=\"3.2\" mask=\"url(#a)\"/><mask id=\"b\" fill=\"#fff\"><rect x=\"6\" y=\"23.995\" width=\"14\" height=\"14\" rx=\"1.375\"/></mask><rect x=\"6\" y=\"23.995\" width=\"14\" height=\"14\" rx=\"1.375\" stroke=\"#000\" stroke-width=\"3.2\" mask=\"url(#b)\"/><mask id=\"c\" fill=\"#fff\"><rect x=\"24\" y=\"5.995\" width=\"14\" height=\"14\" rx=\"1.375\"/></mask><rect x=\"24\" y=\"5.995\" width=\"14\" height=\"14\" rx=\"1.375\" stroke=\"#000\" stroke-width=\"3.2\" mask=\"url(#c)\"/><path fill=\"var(--theme-primary, #810ea9)\" d=\"M24 23.995h3.5v3.5H24zm3.5 3.5H31v3.5h-3.5zm3.5-3.5h3.5v3.5H31zm-7 7.001h3.5v3.5H24zm3.5 3.499H31v3.5h-3.5zm3.5-3.499h3.5v3.5H31zm3.5-3.501H38v3.5h-3.5zm0 7H38v3.5h-3.5z\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/retrive-qr-code.4bca5505b616b377222d5c8f84b81f9f.svg"),
        {
          React: SvgRetriveQrCode,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      